import { format, parseISO } from "date-fns"

export const parseIsoToDate = (iso: string, formatString = "dd/M/yyyy"): string => {
	return format(parseISO(iso), formatString);
}